angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/login/first-step.html',
    '<update-title title="PEforHire.com"></update-title>\n' +
    '\n' +
    '<!-- Header -->\n' +
    '<header class="logo-bar">\n' +
    '	<div class="container-fluid-white">\n' +
    '		<a href="" ui-sref="index" class="logo">\n' +
    '			<svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '				<polygon class="pol-a white" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53"/>\n' +
    '				<polygon class="pol-b white" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7"/>\n' +
    '				<polygon class="pol-c white" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3"/>\n' +
    '			</svg>\n' +
    '			<div class="white">\n' +
    '				<strong class="white">pe</strong><span>4</span>h\n' +
    '			</div>\n' +
    '		</a>\n' +
    '	</div>\n' +
    '</header>\n' +
    '\n' +
    '<!-- 1st Step -->\n' +
    '<section class="content first-step">\n' +
    '	<div class="container-fluid gradient-blu">\n' +
    '		<h3 class="hidden-xs">We\'re Glad to Have You!</h3>\n' +
    '		<h2>What Would You Like To Do?</h2>\n' +
    '		<div class="row">\n' +
    '			<div class="col-xs-12">\n' +
    '				<ul class="list-inline">\n' +
    '					<li class="vertical-middle">\n' +
    '						<div class="vertical-block option-box">\n' +
    '							<div class="icon-measure"></div>\n' +
    '							<h5>I need a Professional Engineer</h5>\n' +
    '							<a class="btn btn-primary btn-lg mt40" href="" ui-sref="post-project"  onclick="document.getElementById(\'loading\').className=\'\';">Post a Project</a>\n' +
    '						</div>\n' +
    '					</li>\n' +
    '					<li class="vertical-middle">\n' +
    '						<div class="vertical-block">\n' +
    '							<div class="icon"></div>\n' +
    '						</div>\n' +
    '					</li>\n' +
    '					<li class="vertical-middle">\n' +
    '						<div class="vertical-block option-box">\n' +
    '							<div class="icon-engineer"></div>\n' +
    '							<h5>I\'m looking for a Project</h5>\n' +
    '							<a class="btn btn-primary btn-lg mt40" href="" ui-sref="signup" onclick="document.getElementById(\'loading\').className=\'\';">I\'m an Engineer</a>\n' +
    '						</div>\n' +
    '					</li>\n' +
    '				</ul>\n' +
    '			</div>\n' +
    '		</div>\n' +
    '	</div>\n' +
    '</section>\n' +
    '');
}]);
